import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "strong",
    [
      _vm._v(_vm._s(_vm.$t("chatbots.dashboard.Indicadores"))),
      _c(
        VRow,
        { staticClass: "pr-2" },
        [
          _c(
            VCol,
            {
              staticClass:
                "col-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 mt-2 pr-0",
            },
            [
              _c(
                VCard,
                { staticClass: "p-3", attrs: { "min-height": "80px" } },
                [
                  _c(
                    VRow,
                    [
                      _c(
                        VCol,
                        { attrs: { cols: "12", md: "4" } },
                        [
                          _c(
                            VMenu,
                            {
                              attrs: {
                                "close-on-content-click": false,
                                transition: "scale-transition",
                                "offset-y": "",
                                "min-width": "290px",
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "activator",
                                  fn: function (ref) {
                                    var on = ref.on
                                    var attrs = ref.attrs
                                    return [
                                      _c(
                                        VTextField,
                                        _vm._g(
                                          _vm._b(
                                            {
                                              attrs: {
                                                "append-icon": "event",
                                                readonly: "",
                                                dense: "",
                                                outlined: "",
                                                "hide-details": "auto",
                                                label: _vm.$t(
                                                  "chatbots.dashboard.range_date"
                                                ),
                                                rules: _vm.dateRangeRules,
                                              },
                                              model: {
                                                value: _vm.formattedDate,
                                                callback: function ($$v) {
                                                  _vm.formattedDate = $$v
                                                },
                                                expression: "formattedDate",
                                              },
                                            },
                                            "v-text-field",
                                            attrs,
                                            false
                                          ),
                                          on
                                        )
                                      ),
                                    ]
                                  },
                                },
                              ]),
                              model: {
                                value: _vm.menu,
                                callback: function ($$v) {
                                  _vm.menu = $$v
                                },
                                expression: "menu",
                              },
                            },
                            [
                              _c(VDatePicker, {
                                attrs: { range: "", scrollable: "" },
                                on: {
                                  input: _vm.updateFormattedDate,
                                  change: _vm.changeRangeDate,
                                },
                                model: {
                                  value: _vm.dateRange,
                                  callback: function ($$v) {
                                    _vm.dateRange = $$v
                                  },
                                  expression: "dateRange",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm.userInfo.userRoles &&
                      (_vm.userInfo.userRoles.includes("ml_steward") ||
                        _vm.userInfo.userRoles.includes("ml_developer"))
                        ? _c(
                            VCol,
                            { attrs: { cols: "12", md: "4" } },
                            [
                              _c("organizacion-component", {
                                attrs: {
                                  custom_orgs: _vm.list_orgs,
                                  show_all: false,
                                },
                                on: { change: _vm.changeDomain },
                                model: {
                                  value: _vm.selectedDomain,
                                  callback: function ($$v) {
                                    _vm.selectedDomain = $$v
                                  },
                                  expression: "selectedDomain",
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.userInfo.userRoles &&
                      _vm.userInfo.userRoles.includes("ml_steward")
                        ? _c(
                            VCol,
                            { attrs: { cols: "12", md: "4" } },
                            [
                              _c(VAutocomplete, {
                                attrs: {
                                  items: _vm.projects,
                                  label: _vm.$t("chatbots.dashboard.project"),
                                  dense: "",
                                  outlined: "",
                                  "hide-details": "auto",
                                  "item-text": "project_name",
                                  "item-value": "id",
                                  "prepend-icon": "mdi-briefcase",
                                  clearable: "",
                                },
                                on: { change: _vm.changeProject },
                                model: {
                                  value: _vm.selectedProject,
                                  callback: function ($$v) {
                                    _vm.selectedProject = $$v
                                  },
                                  expression: "selectedProject",
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            VCol,
            {
              staticClass:
                "col-12 col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-6 mt-2 pr-0",
            },
            [
              _vm.userInfo && _vm.userInfo.orgs && _vm.userInfo.orgs.length
                ? _c("chatMembers", {
                    key: _vm.chatMembersKey,
                    attrs: {
                      selectedMails: _vm.selectedMails,
                      requestPayload: _vm.buildRequest(),
                    },
                    on: { check: _vm.changeMails },
                  })
                : _vm._e(),
            ],
            1
          ),
          _c(
            VCol,
            {
              staticClass:
                "col-12 col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-6 mt-2 pr-0",
            },
            [
              _c("DateResources", {
                attrs: {
                  total_projects_dev: _vm.dataProject.total_projects_prod,
                  total_projects_prod: _vm.dataProject.total_projects_prod,
                  total_projects_prod_limit:
                    _vm.dataProject.total_projects_prod_limit,
                  total_messages: _vm.dataProject.total_messages,
                  total_sessions: _vm.dataProject.total_sessions,
                },
              }),
            ],
            1
          ),
          _c(
            VCol,
            {
              staticClass:
                "col-12 col-xl-9 col-lg-9 col-md-9 col-sm-12 col-xs-12 mt-2 pr-0",
            },
            [
              _c(
                VCard,
                { staticClass: "p-3", attrs: { "min-height": "450px" } },
                [
                  _vm.isLoadingMessages
                    ? _c(VProgressLinear, {
                        attrs: {
                          indeterminate: "",
                          color: "primary",
                          height: "3",
                        },
                      })
                    : _vm._e(),
                  _c("div", {
                    ref: "messagesChart",
                    attrs: { id: "messages-chart" },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            VCol,
            {
              staticClass:
                "col-12 col-xl-3 col-lg-3 col-md-3 col-sm-12 col-xs-12 mt-2 pr-0",
            },
            [
              _c(
                VCard,
                {
                  staticClass: "mb-2 p-3",
                  attrs: { "max-height": "600px", "min-height": "140px" },
                },
                [
                  _vm.isLoadingSessions
                    ? _c(VProgressLinear, {
                        attrs: {
                          indeterminate: "",
                          color: "primary",
                          height: "3",
                        },
                      })
                    : _vm._e(),
                  _c("div", {
                    ref: "sessionsChart",
                    attrs: { id: "sessions-chart" },
                  }),
                ],
                1
              ),
              _c(
                VCard,
                {
                  staticClass: "mb-2 p-3",
                  attrs: { "max-height": "600px", "min-height": "140px" },
                },
                [
                  _vm.isLoadingActivity
                    ? _c(VProgressLinear, {
                        attrs: {
                          indeterminate: "",
                          color: "primary",
                          height: "3",
                        },
                      })
                    : _vm._e(),
                  _c("div", {
                    ref: "activityChart",
                    attrs: { id: "activity-chart" },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }